/* eslint-disable compat/compat */
import { type TOptionsBase, t } from 'i18next';
import isBic from 'validator/lib/isBIC';
import * as Yup from 'yup';

import { createTranslationLink } from 'translations/helpers';
import { truncateArrayPath } from 'utils/string';

const COMMON_RULES = ['required', 'min', 'max', 'email', 'matches', 'oneOf', 'url'];

const rules: Record<string, typeof COMMON_RULES> = {
  mixed: COMMON_RULES,
  string: COMMON_RULES,
  number: COMMON_RULES,
  date: COMMON_RULES,
  boolean: COMMON_RULES,
  object: COMMON_RULES,
  array: COMMON_RULES,
};

function getErrorKey(rule: string, type: string, path?: string) {
  if (rule === 'min' || rule === 'max') {
    return `errors:yup.${rule}.${type}`;
  }

  // ! Workaround for the new Password Confirmation validation case - probably will need some adjustments in the future
  if (rule === 'oneOf' && path != null) {
    return `errors:yup.${rule}.${path}`;
  }

  return `errors:yup.${rule}`;
}

Yup.setLocale(
  Object.fromEntries(
    Object.keys(rules).map((type) => [
      type,
      Object.fromEntries(
        rules[type].map((rule) => [
          rule,
          (params: TOptionsBase & { path: string }) =>
            t(getErrorKey(rule, type, params.path), {
              ...params,
              field: t(`common:form.${truncateArrayPath(params.path)}`, { interpolation: { escapeValue: false } }),
              interpolation: { escapeValue: false },
            }),
        ]),
      ),
    ]),
  ),
);

// Yup custom methods
Yup.addMethod(Yup.string, 'bic', function validationMethod() {
  return this.test(
    'BIC is valid',
    createTranslationLink('errors:yup.invalid', { field: t('common:form.bic') }),
    (value = '') => {
      return isBic(value);
    },
  );
});
